var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ListTable',{ref:"table",attrs:{"headers":_vm.headers,"columns":_vm.columns,"filters":_vm.filters,"actions":_vm.actions,"options":_vm.options,"route":_vm.route,"manual-options":""},on:{"update:options":function($event){_vm.options=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }